import { useState, useEffect } from 'react';

const HMH_BUNDLE_SCRIPT_URLS = ['hmh.standalone-bundle.js', 'hmh.bundle.js'];

/**
 * Checks all script tags in the document for a src containing any of the HMH bundle URLs.
 */
const checkForHMHScript = () => {
  if (typeof document === 'undefined') {
    return false;
  }
  try {
    const scripts = document.querySelectorAll('script[src]');
    return Array.from(scripts).some(script => HMH_BUNDLE_SCRIPT_URLS.some(url => script.src.includes(url)));
  } catch (error) {
    // eslint-disable-next-line
    console.error(`Error checking for HMH script: ${error.message}`);
    return false;
  }
};

/**
 * A custom hook that tracks if the HMH bundle script is loaded.
 */
const useHMHScriptLoaded = () => {
  const [hasLoaded, setHasLoaded] = useState(checkForHMHScript());
  useEffect(() => {
    setHasLoaded(checkForHMHScript());
  }, []);
  return hasLoaded;
};

export { useHMHScriptLoaded as u };
//# sourceMappingURL=useHasHMHScriptLoaded-CEqYoUYv.js.map
